export enum FilterName {
  Category = 'category',
  Type = 'type',
  DatesRange = 'datesRange'
}
